<template>
  <div>
    <v-tabs v-model="tab" align-with-title>
      <v-tabs-slider color="secondary"></v-tabs-slider>
      <v-tab>Builds</v-tab>
      <v-tab>Rollouts</v-tab>
      <v-tab>Stats</v-tab>
    </v-tabs>
    <keep-alive>
      <component 
        :is="currentTabComponent"
        :refresh-rollouts="refreshRollouts"
        :refresh-builds="refreshBuilds"
        @refreshRollouts="incrementRollouts" 
        @refreshBuilds="incrementBuilds"
      />
    </keep-alive>
  </div>
</template>

<script>

import Builds from './tabs/Builds.vue' 
import Rollouts from './tabs/Rollouts.vue' 
import Stats from './tabs/Stats.vue'

export default {
  name: 'FirmwareManagement',

  components: {
    Builds,
    Rollouts,
    Stats
  },

  data() {
    return {
      tab: 0,
      refreshRollouts: 0,
      refreshBuilds: 0
    }
  },

  computed: {
    currentTabComponent() {
      switch (this.tab) {
        case 0:
          return "Builds"
        case 1:
          return "Rollouts"
        case 2:
          return "Stats"
        default:
          return "Builds"
      }
    }
  },

  methods: {
    incrementRollouts() {
      this.refreshRollouts++
    },

    incrementBuilds() {
      this.refreshBuilds++
    }
  }
}
</script>